/**
 * Host messages for background queue work. They carry only what the durable
 * record knows and classification codes, never answers, tokens or responses.
 */
export function queueResultMessage(result) {
  if (result.kind !== 'final') return null;

  const data = { channel_id: result.nodeId, flow_id: result.flowId, submission_id: result.submissionId };

  if (result.status === 'submitted') {
    return { type: 'PSN_QUEUED_FEEDBACK_SENT', data: { ...data, feedback_id: result.feedbackId ?? null } };
  }

  const { failure } = result;

  // Unsaved failures and transient preparation failures are not outcomes yet.
  if (result.status !== 'failed' || failure?.status !== 'blocked') return null;

  // An interrupted POST may have been accepted and reported as sent before its
  // record could be removed. It is a diagnostic, never a second outcome.
  if (failure.kind === 'interrupted') return null;

  const codes = { stage: failure.stage, http_status: failure.httpStatus, api_code: failure.apiCode };

  if (failure.stage === 'post') {
    return {
      type: 'PSN_QUEUED_FEEDBACK_FAILED',
      data: { ...data, outcome: failure.outcome, reason: failure.kind, ...codes },
    };
  }

  return {
    type: 'PSN_QUEUED_FEEDBACK_BLOCKED',
    data: { ...data, reason: failure.kind, ...codes },
  };
}

export function queueStatusMessage({ pendingCount, blockedCount, inProgress }) {
  return {
    type: 'PSN_FEEDBACK_QUEUE_STATUS',
    data: { pending_count: pendingCount, blocked_count: blockedCount, in_progress: inProgress },
  };
}
